import ResumenPago from 'components/Resumen/ResumenPago'
import React, { useState } from 'react'
import { PRODUCTOS } from 'utils/constants'
import { ModalInfoResumen } from './Componentes/ModalInfoResumen'
import { DO } from './constantes/general'

export const DOResumen = (props) => {

    const [showInfoModal, setShowInfoModal] = useState(false);
    const [info, setInfo] = useState([])

    const procesarInfo = (data) => {
        data.prodDatos[0].planSeleccionado.etiquetas = data?.prodDatos?.[0]?.planSeleccionado?.etiquetas?.map(etiqueta => {
            if (etiqueta?.showModal) {
                etiqueta.onClick = (setShowModal) => {
                    setShowModal(true);
                }
            }
            return etiqueta;
        })
        setInfo(data?.prodDatos?.[0]?.planSeleccionado?.infoModal);
        return (data);
    }

    return (
        <>
            <ResumenPago productoCodigoCore={PRODUCTOS.DO}
                urlGoTo={DO.urls.facturacion}
                urlBackTo={DO.urls.planes}
                procesarInfo={procesarInfo}
                setShowInfoModal={setShowInfoModal}
                {...{ ...props }}></ResumenPago>
            <ModalInfoResumen setShowModal={setShowInfoModal} showModal={showInfoModal} info={info}/>
        </>
    )
}
